import { createActions } from "redux-actions";

export const { setAdminOpenedNodes, setBusinessNetwork } = createActions({
  SET_ADMIN_OPENED_NODES: ({ items }) => ({ items }),
  SET_BUSINESS_NETWORK: ({ items }) => ({ items }),
});
